/**
 * SearchLog 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * SearchLog
 */
export interface SearchLog {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 用户ID（可为空，支持匿名搜索） */
  user_id?: string
  /** 搜索关键词 */
  keyword?: string
  /** 关键词MD5哈希，用于聚合统计 */
  keyword_hash?: string
  /** 搜索结果数量（用于热搜计算时判断是否有效搜索） */
  result_count?: number
  /** 设备ID（来自 X-Device-ID，用于匿名搜索统计和防刷检测） */
  device_id?: string
}

/**
 * SearchLog Schema
 */
export const SearchLogSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    user_id: {
      description: '用户ID（可为空，支持匿名搜索）',
      format: 'string',
      type: 'string',
      label: '用户ID',
    },
    keyword: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    keyword_hash: {
      description: '关键词MD5哈希，用于聚合统计',
      format: 'string',
      type: 'string',
      label: '关键词MD5哈希',
    },
    result_count: {
      description: '搜索结果数量（用于热搜计算时判断是否有效搜索）',
      format: 'int',
      type: 'integer',
      label: '搜索结果数量',
    },
    device_id: {
      description: '设备ID（来自 X-Device-ID，用于匿名搜索统计和防刷检测）',
      format: 'string',
      type: 'string',
      label: '设备ID',
    },
  },
  type: 'object',
}
